import axios from "axios";
import store from "../store";
import Router from "@/router/index";

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  timeout: 15000, // 请求超时时间
});
// request拦截器
service.interceptors.request.use(
  (config) => {
    if (localStorage.getItem("dclass_token")) {
      config.headers["token"] = localStorage.getItem("dclass_token");
    }
    return config;
  },
  (error) => {
    // 请求错误则向store commit这个状态变化
    const httpError = {
      hasError: true,
      status: error.response.status,
      statusText: error.response.statusText,
    };
    store.commit("ON_HTTP_ERROR", httpError);
    // Do something with request error
    return Promise.reject(error);
  }
);

service.interceptors.response.use(
  (response) => {
    const resp = response.data;
    if (response.data.code === 440) {
      localStorage.clear();
      sessionStorage.clear();
      if (window.location.hash.endsWith("/home")) {
        store.state.login = 0;
      } else {
        Router.push("/login");
      }
    }
    if (response.status === 200) {
      return resp;
    } else {
      return resp;
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default service;
